import React, { useRef } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { sendTicketEmailAndSMS } from "../services/mytrips.services";
import Loading from "../../../components/spinner/Loading";

const SendTicketDialog = ({ portal_booking_no }: any) => {
  const dispatch = useAppDispatch();
  const emailLoading = useAppSelector((state) => state?.mytrips?.emailLoading);

  const closeBtnRef = useRef<any>(null);

  const formik = useFormik({
    initialValues: {
      email: "",
      mobile: "",
    },
    validationSchema: Yup.object()
      .shape({
        email: Yup.string().matches(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          "Invalid email format"
        ),
        mobile: Yup.string().matches(
          /^[0-9]{10}$/,
          "Mobile number must be 10 digits"
        ),
      })
      .test(
        "at-least-one-contact",
        "Either email or mobile number is required",
        function (values) {
          const { email, mobile } = values;
          if (!email && !mobile) {
            return this.createError({
              path: "email",
              message: "Either email or mobile number is required",
            });
          }
          return true;
        }
      ),
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      const payload = {
        email: values?.email ? values?.email : "",
        mobile: values?.mobile ? `${values?.mobile}` : "",
        Booking_RefNo: portal_booking_no,
        Airline_PNR: "",
      };
      const response = await dispatch(sendTicketEmailAndSMS(payload));
      if (response.meta.requestStatus === "fulfilled") {
        setSubmitting(false);
        resetForm();
        if (closeBtnRef.current) {
          closeBtnRef.current.click();
        }
      }
    },
    enableReinitialize: true,
  });
  return (
    <form
      className="modal fade"
      id="sendticket-form"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex={-1}
      aria-labelledby="send-email-sms"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-dialog-centered "
        style={{ maxWidth: 600 }}
      >
        <div className="modal-content profile-heading p-0 align-items-start position-relative overflow-hidden">
          <Loading loading={emailLoading} />
          <div className="modal-header">
            <h4 className="modal-title fs-5" id="send-email-sms">
              Send E-ticket on E-mail and Mobile No.
            </h4>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              disabled={emailLoading}
              onClick={() => formik.resetForm()}
            ></button>
          </div>
          <div
            className="modal-body travel-form-detail w-100"
            style={{ borderTop: "1px dashed #acacac" }}
          >
            <div className="travel-form">
              <div className="d-flex justify-content-between gap-3">
                <div className="field w-100">
                  <label
                    className={
                      formik.touched.email && formik.errors.email
                        ? "error-label"
                        : ""
                    }
                  >
                    Email ID
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={
                      formik.touched.email && formik.errors.email
                        ? "error-border"
                        : ""
                    }
                  />
                  {formik.touched.email &&
                  formik.errors.email &&
                  typeof formik.errors.email === "string" ? (
                    <div className="error-label">{formik.errors.email}</div>
                  ) : null}
                </div>
                <div className="field w-100">
                  <label
                    className={
                      formik.touched.mobile && formik.errors.mobile
                        ? "error-label"
                        : ""
                    }
                  >
                    Mobile No
                  </label>
                  <input
                    type="number"
                    name="mobile"
                    value={formik.values.mobile}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    onInput={(e: any) => {
                      return (e.target.value = Math.max(
                        0,
                        parseInt(e.target.value)
                      )
                        .toString()
                        .slice(0, 10));
                    }}
                    className={
                      formik.touched.mobile && formik.errors.mobile
                        ? "error-border"
                        : ""
                    }
                  />
                  {formik.touched.mobile &&
                  formik.errors.mobile &&
                  typeof formik.errors.mobile === "string" ? (
                    <div className="error-label">{formik.errors.mobile}</div>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="travel-detail-btns mt-4">
              <a
                className="disable"
                href="javascript:void(0)"
                data-bs-dismiss="modal"
                ref={closeBtnRef}
                onClick={() => formik.resetForm()}
              >
                Cancel
              </a>
              <a
                href="javascript:void(0)"
                onClick={() => formik.handleSubmit()}
              >
                Send
              </a>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default SendTicketDialog;
